module.exports = __webpack_public_path__ + "img/num_11.cf285d64.png";